<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">Motorista | {{ id }}</p>
          <div class="heading-elements">
            <i
              class="fas fa-long-arrow-alt-left position-left"
              @click="voltar()"
              style="cursor: pointer"
            ></i>
          </div>
        </div>
        <div class="box-body">
          <div v-show="errorMessage != ''" class="alert alert-danger">
            {{ errorMessage }}
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="nome">Nome <sup class="text-danger">* </sup></label>
              <input
                id="nome"
                v-model="registro.nome"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.nome }"
              />
              <span v-show="errors.nome != null" class="help-inline">{{ errors.nome }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="idc_status">Status <sup class="text-danger">* </sup></label>
              <select
                id="idc_status"
                v-model="registro.idc_status"
                style="width: auto"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.idc_status }"
              >
                <option value="1">Ativo</option>
                <option value="2">Reprovado</option>
                <option value="13">Aguardando Pré-análise</option>
                <option value="3">Aguardando Validação</option>
                <option value="4">Agendamento Solicitado</option>
                <option value="5" v-show="registro.idc_status === 5">Aguardando Agendamento</option>
                <option value="6" v-show="registro.idc_status === 6">Aguardando Ponto de Apoio</option>
                <option value="7" v-show="registro.idc_status === 7">Aguardando Equipamento</option>
                <option value="8" v-show="registro.idc_status === 8">Agendamento Realizado</option>
                <option value="14">Cadastro não Finalizado - Pré-aprovado</option>
                <option value="9">Excluído</option>
                <option value="10">Outras Praças</option>
                <option value="11">Pendente</option>
                <option value="12">Furto, Roubo ou Avaria</option>
                <option value="15">Serasa</option>
              </select>
              <span v-show="errors.idc_status != null" class="help-inline">{{ errors.idc_status }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="cpf">CPF <sup class="text-danger">* </sup></label>
              <input
                id="cpf"
                v-model="registro.cpf"
                v-mask="'###.###.###-##'"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.cpf }"
              />
              <span v-show="errors.cpf != null" class="help-inline">{{ errors.cpf }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="idc_termo_aceito">Termo <sup class="text-danger">* </sup></label>
              <select
                id="idc_termo_aceito"
                v-model="registro.idc_termo_aceito"
                style="width: auto"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.idc_termo_aceito }"
              >
                <option value="1">Aceito</option>
                <option value="2">Não Aceito</option>
                <option value="3">Pendente</option>
              </select>
              <span v-show="errors.idc_termo_aceito != null" class="help-inline">{{ errors.idc_termo_aceito }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="email">E-mail <sup class="text-danger">* </sup></label>
              <input
                id="email"
                v-model="registro.email"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.email }"
              />
              <span v-show="errors.email != null" class="help-inline">{{ errors.email }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="tel_celular">Telefone <sup class="text-danger">* </sup></label>
              <input
                id="tel_celular"
                v-model="registro.tel_celular"
                v-mask="'(##) ####-#####'"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.tel_celular }"
              />
              <span v-show="errors.tel_celular != null" class="help-inline">{{ errors.tel_celular }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="end_cep">CEP <sup class="text-danger">* </sup></label>
              <input
                id="end_cep"
                v-model="registro.end_cep"
                v-mask="'##.###-###'"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.end_cep }"
                @keyup="pesquisarCEP()"
              />
              <span v-show="errors.end_cep != null" class="help-inline">{{ errors.end_cep }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="end_logradouro">Logradouro <sup class="text-danger">* </sup></label>
              <input
                id="end_logradouro"
                v-model="registro.end_logradouro"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.end_logradouro }"
              />
              <span v-show="errors.end_logradouro != null" class="help-inline">{{ errors.end_logradouro }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="end_numero">Número <sup class="text-danger">* </sup></label>
              <input
                id="end_numero"
                v-model="registro.end_numero"
                v-mask="'##########'"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.end_numero }"
              />
              <span v-show="errors.end_numero != null" class="help-inline">{{ errors.end_numero }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="end_complemento">Complemento </label>
              <input
                id="end_complemento"
                v-model="registro.end_complemento"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.end_complemento }"
              />
              <span
                v-show="errors.end_complemento != null"
                class="help-inline"
                >{{ errors.end_complemento }}</span
              >
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="end_bairro">Bairro <sup class="text-danger">* </sup></label>
              <input
                id="end_bairro"
                v-model="registro.end_bairro"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.end_bairro }"
              />
              <span v-show="errors.end_bairro != null" class="help-inline">{{ errors.end_bairro }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="end_cidade">Cidade <sup class="text-danger">* </sup></label>
              <input
                id="end_cidade"
                v-model="registro.end_cidade"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.end_cidade }"
              />
              <span v-show="errors.end_cidade != null" class="help-inline">{{ errors.end_cidade }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="end_uf">UF <sup class="text-danger">* </sup></label>
              <select
                id="end_uf"
                v-model="registro.end_uf"
                style="width: auto"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.end_uf }"
              >
                <option value="AC">AC</option>
                <option value="AL">AL</option>
                <option value="AM">AM</option>
                <option value="AP">AP</option>
                <option value="BA">BA</option>
                <option value="CE">CE</option>
                <option value="DF">DF</option>
                <option value="ES">ES</option>
                <option value="GO">GO</option>
                <option value="MA">MA</option>
                <option value="MG">MG</option>
                <option value="MS">MS</option>
                <option value="MT">MT</option>
                <option value="PA">PA</option>
                <option value="PB">PB</option>
                <option value="PE">PE</option>
                <option value="PI">PI</option>
                <option value="PR">PR</option>
                <option value="RJ">RJ</option>
                <option value="RN">RN</option>
                <option value="RO">RO</option>
                <option value="RR">RR</option>
                <option value="RS">RS</option>
                <option value="SC">SC</option>
                <option value="SE">SE</option>
                <option value="SP">SP</option>
                <option value="TO">TO</option>
              </select>
              <span v-show="errors.end_uf != null" class="help-inline">{{ errors.end_uf }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="end_pais">País <sup class="text-danger">* </sup></label>
              <select
                id="end_pais"
                v-model="registro.end_pais"
                style="width: auto"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.end_pais }"
              >
                <option value="0639">ARGENTINA</option>
                <option value="0973">BOLIVIA</option>
                <option value="1058">BRASIL</option>
                <option value="1589">CHILE</option>
                <option value="1694">COLOMBIA</option>
                <option value="2399">EQUADOR</option>
                <option value="2496">ESTADOS UNIDOS</option>
                <option value="4936">MEXICO</option>
                <option value="5860">PARAGUAI</option>
                <option value="5894">PERU</option>
                <option value="8451">URUGUAI</option>
                <option value="8508">VENEZUELA</option>
              </select>
              <span v-show="errors.end_pais != null" class="help-inline">{{ errors.end_pais }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="end_latitude">Latitude </label>
              <input
                id="end_latitude"
                v-model="registro.end_latitude"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.end_latitude }"
              />
              <span v-show="errors.end_latitude != null" class="help-inline">{{ errors.end_latitude }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="end_longitude">Longitude</label>
              <input
                id="end_longitude"
                v-model="registro.end_longitude"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.end_longitude }"
              />
              <span v-show="errors.end_longitude != null" class="help-inline">{{ errors.end_longitude }}</span>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="observacao">Observação</label>
              <textarea
                id="observacao"
                v-model="registro.observacao"
                maxlength="1000"
                type="text"
                class="form-control"
                v-bind:class="{ 'box-input-required': errors.observacao }"
              ></textarea>
              <span v-show="errors.observacao != null" class="help-inline">{{ errors.observacao }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="genero">Gênero:</label>
              <select
                id="genero"
                v-model="registro.genero"
                style="width: auto"
                class="form-control"
              >
                <option value=""></option>
                <option value="Não informado">Não informado</option>
                <option value="M">Masculino</option>
                <option value="F">Feminino</option>
                <option value="O">Outros</option>
                <option value="P">Prefiro não informar</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="aceita_receber_whatsapp">Aceita receber mensagens no whatsapp ?</label>
              <select
                id="aceita_receber_whatsapp"
                v-model="registro.aceita_receber_whatsapp"
                style="width: auto"
                class="form-control"
              >
                <option value=""></option>
                <option value="true">Sim</option>
                <option value="false">Não</option>
              </select>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="primeiro_acesso">Primeiro acesso:</label>
              <select
                id="primeiro_acesso"
                v-model="registro.primeiro_acesso"
                style="width: auto"
                class="form-control"
              >
                <option value=""></option>
                <option value="true">Sim</option>
                <option value="false">Não</option>
              </select>
            </div>
          </div>
        </div>
        <div class="box-footer text-center">
          <div class="btn-group">
            <button
              type="button"
              id="cancelButton"
              class="btn btn-warning"
              @click="voltar()"
            >
              Cancelar
            </button>
            <button
              type="button"
              id="gravarButton"
              class="btn btn-success"
              @click="gravar()"
            >
              Gravar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isValidCep, isValidCpf } from '@brazilian-utils/validators'
import { validate as isEmail } from 'email-validator'
import MotoristaActions from '../../actions/MotoristaActions'

export default {
  name: 'editar',
  props: ['id'],
  data () {
    return {
      errorMessage: '',
      errors: {},
      hasError: false,
      registro: {
        nome: '',
        email: '',
        cpf: '',
        tel_celular: '',
        end_cep: '',
        end_logradouro: '',
        end_numero: '',
        end_complemento: '',
        end_bairro: '',
        end_cidade: '',
        end_uf: '',
        end_pais: '',
        end_latitude: '',
        end_longitude: '',
        idc_status: '',
        idc_termo_aceito: '',
        genero: '',
        observacao: '',
        primeiro_acesso: '',
        aceita_receber_whatsapp: ''
      }
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Editar'
    this.$parent.$parent.$data.showModalLoader = true

    MotoristaActions.obterMotorista(this.id)
      .then(res => {
        if (res && res.nome) {
          this.registro = res
        } else {
          this.errorMessage = 'Registro não encontrado.'
        }
        this.$parent.$parent.$data.showModalLoader = false
      })
      .catch(error => {
        console.log(error.message)
        this.errorMessage = 'Registro não encontrado.'
        this.$parent.$parent.$data.showModalLoader = false
      })
  },
  methods: {
    voltar () {
      this.$router.push(
        this.$route.query.ret_url ? this.$route.query.ret_url : '/motoristas'
      )
    },
    validation () {
      this.errors = {}
      this.hasError = false
      if (!this.registro.nome) {
        this.errors.nome = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
      if (!this.registro.email) {
        this.errors.email = 'Este campo deve ser preenchido.'
        this.hasError = true
      } else if (!isEmail(this.registro.email)) {
        this.errors.email = 'E-mail inválido.'
        this.hasError = true
      } else {
        MotoristaActions.verificarEmailEmUso(this.registro.email, this.id).then(
          emUso => {
            if (emUso) {
              this.errors.email = 'E-mail já em uso por outro usuário.'
              this.hasError = true
            }
          }
        )
      }
      if (!this.registro.cpf) {
        this.errors.cpf = 'Este campo deve ser preenchido.'
        this.hasError = true
      } else if (!isValidCpf(this.registro.cpf)) {
        this.errors.cpf = 'CPF inválido.'
        this.hasError = true
      }
      if (!this.registro.tel_celular) {
        this.errors.tel_celular = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
      if (!this.registro.end_cep) {
        this.errors.end_cep = 'Este campo deve ser preenchido.'
        this.hasError = true
      } else if (this.cepNaoEncontrado) {
        this.errors.end_cep = 'CEP não encontrado.'
        this.hasError = true
      }
      if (!this.registro.end_logradouro) {
        this.errors.end_logradouro = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
      if (!this.registro.end_numero) {
        this.errors.end_numero = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
      if (!this.registro.end_bairro) {
        this.errors.end_bairro = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
      if (!this.registro.end_cidade) {
        this.errors.end_cidade = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
      if (!this.registro.end_uf) {
        this.errors.end_uf = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
      if (!this.registro.end_pais) {
        this.errors.end_pais = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
      if (!this.registro.idc_status) {
        this.errors.idc_status = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
      if (!this.registro.idc_termo_aceito) {
        this.errors.idc_termo_aceito = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
    },
    gravar () {
      this.validation()

      if (!this.hasError) {
        this.$parent.$parent.$data.showModalLoader = true

        MotoristaActions
          .alterarMotorista({
            id: this.id,
            nome: this.registro.nome,
            email: this.registro.email,
            cpf: this.registro.cpf,
            tel_celular: this.registro.tel_celular,
            end_cep: this.registro.end_cep,
            end_logradouro: this.registro.end_logradouro,
            end_numero: this.registro.end_numero,
            end_complemento: this.registro.end_complemento,
            end_bairro: this.registro.end_bairro,
            end_cidade: this.registro.end_cidade,
            end_uf: this.registro.end_uf,
            end_pais: this.registro.end_pais,
            end_latitude: this.registro.end_latitude,
            end_longitude: this.registro.end_longitude,
            horario_atend_ini: this.registro.horario_atend_ini,
            horario_atend_fim: this.registro.horario_atend_fim,
            capacidade_atend_dia: this.registro.capacidade_atend_dia,
            raio_atuacao: this.registro.raio_atuacao,
            idc_status: this.registro.idc_status,
            idc_termo_aceito: this.registro.idc_termo_aceito,
            genero: this.registro.genero,
            observacao: this.registro.observacao,
            primeiro_acesso: this.registro.primeiro_acesso,
            aceita_receber_whatsapp: this.registro.aceita_receber_whatsapp
          })
          .then(() => {
            this.$parent.$parent.$data.showModalLoader = false
            this.$router.push('/motoristas')
          })
          .catch(() => {
            this.errorMessage = 'Ocorreu um erro ao gravar o registro.'
            this.$parent.$parent.$data.showModalLoader = false
          })
      }
    },
    pesquisarCEP () {
      if (isValidCep(this.registro.end_cep)) {
        if (this.ultimoCEP !== this.registro.end_cep) {
          this.$parent.$parent.$data.showModalLoader = true
          this.ultimoCEP = this.registro.end_cep

          MotoristaActions
            .pesquisarCep(this.registro.end_cep)
            .then(res => {
              this.registro.end_logradouro = res.logradouro
              this.registro.end_bairro = res.bairro
              this.registro.end_cidade = res.localidade
              this.registro.end_uf = res.uf
              this.errors.end_cep = null
              this.cepNaoEncontrado = false
              this.$parent.$parent.$data.showModalLoader = false
            })
            .catch(() => {
              this.registro.end_logradouro = ''
              this.registro.end_bairro = ''
              this.registro.end_cidade = ''
              this.registro.end_uf = ''
              this.errors.end_cep = 'CEP não encontrado.'
              this.cepNaoEncontrado = true
              this.$parent.$parent.$data.showModalLoader = false
            })
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/motorista/Editar.vue